export enum PaymentStatus {
  CREATED = 'CREATED',
  CANCELLED = 'CANCELLED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
  AUTOMATIC_COMPLETED = 'AUTOMATIC_COMPLETED',
  AUTOMATIC_FAILED = 'AUTOMATIC_FAILED',
}
